import fabric from "../images/fabric.png";

let theme = {
  primary: "#82252f",
}

export default theme
